import { api } from "@/services/api"
import { SongRoot, SongHistoryRoot } from "@/types"

export const getSonglistHistory = async (channel: string, pageNumber: string, itemsPerPage: string) => {
  const data = await api.get<SongHistoryRoot>(
    `/v1/streamers/${channel}/playHistory?size=${itemsPerPage}&current=${pageNumber}&order=desc` // https://api.streamersonglist.com/v1/streamers/23171/songs?size=10&current=0&showInactive=false&isNew=false&order=asc&filterText=trine ---- Katso lisää vinkkejä network tabista, TODO: looppaa pienemmissä erissä
  )
  return data
}

export const getSongs = async (channel: string) => {
  const data = await api.get<SongRoot>(
    `/v1/streamers/${channel}/songs/export`
  )
  return data
}
